import { useEffect } from 'react';

/**
 * Custom hook to set the canonical URL for a page.
 * This directly manipulates the DOM to ensure the canonical tag is set,
 * working around issues with react-helmet-async not adding link tags properly.
 */
export function useCanonical(url) {
  useEffect(() => {
    // Remove any existing canonical link
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Create and append new canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = url;
    document.head.appendChild(link);
    
    // Cleanup on unmount
    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && canonical.href === url) {
        canonical.remove();
      }
    };
  }, [url]);
}

export default useCanonical;
